import Oops from '@members/errors/Oops';

export default function Custom500() {
  return <Oops />;
}
